// src/utils/pseudoGenerator.js

// Mix: Street Food (Dirty, Smash, Crispy) & Football (Golden, Ultra, Total)
const ADJECTIVES = [
    "Golden",     // Golden Boy / Golden Bun
    "Prime",      // Prime Icon / Prime Beef
    "Smash",      // Smash Burger
    "Dirty",      // Dirty Sheet / Dirty Fries
    "Giga",       // Giga Tacos
    "Ultra",      // Ultras Paris
    "Magic",      // Magic System
    "Savage",     // Savage
    "Crispy",     // Croustillant
    "Spicy",      // Piquant
    "Hype",       // La Hype
    "Total",      // Total Football
    "Crazy",      // Crazy Game
    "Double",     // Double Cheese / Doublé
    "Cheesy",     // Fromager
    "Nasty",      // Nasty Food
    "Holy",       // Holy Grail
    "Fast",       // Fast Food
    "Super",      // Super League
    "Mega",       // Mega Menu
    "Drip",       // Le Style
    "Real"        // Real Madrid / Real Taste
];

// Mix: Ingrédients, Statuts (GOAT, Boss) & Postes (Striker, Keeper)
const NOUNS = [
    "Striker",    // Buteur
    "Burger",     // Base
    "GOAT",       // Greatest of All Time
    "Baller",     // Joueur de foot / Street
    "Cheddar",    // Fromage
    "Captain",    // Capitaine
    "Bacon",      // Base
    "Sauce",      // La sauce / La technique
    "Legend",     // Légende
    "Goal",       // But
    "Snack",      // Casse-dalle
    "Winner",     // Vainqueur
    "Keeper",     // Gardien
    "Fries",      // Frites
    "Boss",       // Patron
    "King",       // Roi
    "Squad",      // Équipe
    "Vibe",       // Ambiance
    "Cheat",      // Cheat Meal
    "Dalle",      // La faim
    "Derby",      // Match
    "Tifo"        // Ambiance stade
];

// Mix: Food + Sport + Street
const EMOJIS = [
    "⚽", "🍔", "🍟", "🥅", "🏆", "🥓", "🧀", "🔥", "🌶️", "🥤",
    "👟", "🧤", "🏟️", "🤤", "💣", "🚀", "🐐", "👑", "💯"
];

export const generatePseudo = () => {
    const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
    const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
    const emoji = EMOJIS[Math.floor(Math.random() * EMOJIS.length)];

    // Résultat ex: "GoldenStriker10 ⚽" ou "DirtyCheddar7 🧀"
    return `${adj}${noun} ${emoji}`;
};